__webpack_require__.p = "https://ikea.marat.qd.je/ie/en/customer-service/support/";